import { render, staticRenderFns } from "./Megaphone.vue?vue&type=template&id=068c5e45&"
import script from "./Megaphone.vue?vue&type=script&lang=ts&"
export * from "./Megaphone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports